import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import {Typography} from '@mui/material';
import {CustomContentProps, useSnackbar} from 'notistack';
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {SnackbarContent as CustomSnackbarContent} from './SnackbarContent';
import {useShouldShowTrialUI, useUser} from '../../hooks/session/useSessionSelectors';
import {localFormatISOString} from '../../utils/date-format';

const FreeTrial = React.forwardRef<HTMLDivElement, CustomContentProps>(({id}, ref) => {
  const {closeSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const user = useUser();
  const shouldShowTrialUI = useShouldShowTrialUI();

  if (!shouldShowTrialUI) {
    return <div ref={ref} style={{display: 'none'}} />;
  }

  return (
    <CustomSnackbarContent
      ref={ref}
      titleColor="success"
      color="success"
      bgWhite
      icon={<AccessAlarmIcon />}
      title={t('subscription.currentplan.title.free')}
      content={
        <>
          {user?.earlyAdoptersPremiumExpireAt !== undefined && (
            <Typography variant="body2">
              {t('subscription.premiumfree', {
                date: localFormatISOString(user.earlyAdoptersPremiumExpireAt, 'dd MMMM yyyy', user?.locale ?? 'en'),
              })}
            </Typography>
          )}
        </>
      }
      onClose={handleDismiss}
      dividerColor={false}
    />
  );
});

export {FreeTrial};
